import React, {Component} from 'react';
// helpers
import {getAFMarketNameByCode} from '../../../helpers/marketHelpers';
import {getText} from '../../../../../helpers/localization';
// components
import LockedBet from '../../../components/lockedBet';
import {PLACED, VOIDED} from "../../../../../constants/identifiers";
import style from "../../../css/lockedBetFootball.css";
import {getGameTitle} from "../../../../../helpers/eventHelpers";
import {translateAFUnderOver} from "../../americanFootball/helpers/marketHelpers";

import {
    MONEY_LINE_TOTAL_POINTS,
    MONEYLINE,
    SPREAD_TOTAL_POINTS,
    TOTAL_POINTS_GROUP,
    WINNING_MARGIN
} from "../constants/marketTypes";

class LockedBetAmericanFootball extends Component {

    _createEventDetails(bet) {
        let eventDetails = bet.EventDetails;
        let spreadUI = '';
        if (eventDetails.spread !== '') {
            spreadUI = (<div className={`${style.eventDetailsLine} ${style.even}`}>
                <div className={style.eventDetailsLineLeft}>{getText('SPREAD', this.props.store)}</div>
                <div
                    className={style.eventDetailsLineRight}>{this._getMarketDetails(eventDetails.spread, eventDetails.team1, eventDetails.team2)}</div>
            </div>);
        }
        let underOverUI = '';
        if (eventDetails.underOver !== '') {
            underOverUI = (<div className={`${style.eventDetailsLine} ${style.odd}`}>
                <div className={style.eventDetailsLineLeft}>{getText('TOTAL_POINTS_OVER_UNDER', this.props.store)}</div>
                <div
                    className={style.eventDetailsLineRight}>{this._getMarketDetails(eventDetails.underOver, '', '')}</div>
            </div>);
        }

        let moneyLineUI = '';
        if (bet.Market.Code === MONEYLINE.code && eventDetails.moneyLine !== undefined && eventDetails.moneyLine !== '') {
            moneyLineUI = (<div className={`${style.eventDetailsLine} ${style.even}`}>
                <div className={style.eventDetailsLineLeft}>{getText('MONEYLINE', this.props.store)}</div>
                <div
                    className={style.eventDetailsLineRight}>{this._getMarketDetails(eventDetails.moneyLine, eventDetails.team1, eventDetails.team2)}</div>
            </div>);
        }

        let winningMarginUI = '';
        if (bet.Market.Code === WINNING_MARGIN.code && eventDetails.winningMargin !== undefined && eventDetails.winningMargin !== '') {
            winningMarginUI = (<div className={`${style.eventDetailsLine} ${style.even}`}>
                <div className={style.eventDetailsLineLeft}>{getText('WINNING_MARGIN', this.props.store)}</div>
                <div
                    className={style.eventDetailsLineRight}>{this._getMarketDetails(eventDetails.winningMargin, eventDetails.team1, eventDetails.team2)}</div>
            </div>);
        }

        let totalPointsGroupsUI = '';
        if (bet.Market.Code === TOTAL_POINTS_GROUP.code && eventDetails.totalPointsGroups !== undefined && eventDetails.totalPointsGroups !== '') {
            totalPointsGroupsUI = (<div className={`${style.eventDetailsLine} ${style.even}`}>
                <div className={style.eventDetailsLineLeft}>{getText('TOTAL_POINTS_GROUP', this.props.store)}</div>
                <div
                    className={style.eventDetailsLineRight}>{this._getMarketDetails(eventDetails.totalPointsGroups, eventDetails.team1, eventDetails.team2)}</div>
            </div>);
        }

        let spreadAndUnderOverUI = '';
        if (bet.Market.Code === SPREAD_TOTAL_POINTS.code && eventDetails.spreadAndUnderOver !== undefined && eventDetails.spreadAndUnderOver !== '') {
            spreadAndUnderOverUI = (<div className={`${style.eventDetailsLine} ${style.even}`}>
                <div className={style.eventDetailsLineLeft}>{getText('SPREAD_TOTAL_POINTS', this.props.store)}</div>
                <div
                    className={style.eventDetailsLineRight}>{this._getMarketDetails(eventDetails.spreadAndUnderOver, eventDetails.team1, eventDetails.team2)}</div>
            </div>);
        }

        let moneyLineAndUnderOVerUI = '';
        if (bet.Market.Code === MONEY_LINE_TOTAL_POINTS.code && eventDetails.moneyLineAndUnderOVer !== undefined && eventDetails.moneyLineAndUnderOVer !== '') {
            moneyLineAndUnderOVerUI = (<div className={`${style.eventDetailsLine} ${style.even}`}>
                <div className={style.eventDetailsLineLeft}>{getText('MONEY_LINE_TOTAL_POINTS', this.props.store)}</div>
                <div
                    className={style.eventDetailsLineRight}>{this._getMarketDetails(eventDetails.moneyLineAndUnderOVer, eventDetails.team1, eventDetails.team2)}</div>
            </div>);
        }

        return (
            <div>
                {/* <div className={`${style.eventDetailsLine} ${style.even}`}>
          <div className={style.eventDetailsLineLeft}>{getText('SCORE', this.props.store)}</div>
          <div className={style.eventDetailsLineRight}>10</div>
        </div> */}
                {spreadUI}
                {underOverUI}
                {moneyLineUI}
                {winningMarginUI}
                {totalPointsGroupsUI}
                {spreadAndUnderOverUI}
                {moneyLineAndUnderOVerUI}
            </div>
        );
    }

    _getMarketDetails(selection, awayTeam, homeTeam) {
        let name = '';
        if (selection.toLowerCase().indexOf('home') === 0) {
            name = selection.replace(/Home/ig, awayTeam);
            name = translateAFUnderOver(name, this.props.store);
        } else if (selection.toLowerCase().indexOf('away') === 0) {
            name = selection.replace(/Away/ig, homeTeam);
            name = translateAFUnderOver(name, this.props.store);
        } else if (selection.toLowerCase().indexOf('under') === 0) {
            let number = selection.replace(/Under /ig, "");
            name = getText('Under', this.props.store, [number]);
        } else if (selection.toLowerCase().indexOf('over') === 0) {
            let number = selection.replace(/Over /ig, "");
            name = getText('Over', this.props.store, [number]);
        } else if (isNaN(selection)) {
            name = getText(selection, this.props.store);
        } else {
            name = selection;
        }

        if (name.toLowerCase().indexOf(' and ') > 0) {
            let andText = ' ' + getText('and', this.props.store) + ' '
            name = name.replace(/ And /ig, andText);
        }
        return name;
    }

    render() {

        let eventDetails;
        let bet = this.props.betSelection.Bets[0];

        let homeTeam = getText(bet.EventDetails.team2, this.props.store);
        let awayTeam = getText(bet.EventDetails.team1, this.props.store);

        let voidStatus = bet.State === 'VOIDED';
        let title = `${homeTeam} ${getText('AT', this.props.store)} ${awayTeam}`;
        let eventName = getGameTitle(title, bet.EventTime, this.props.store.getState().vpp.systemLanguage);
        let marketInfo = bet.OpaqueData === undefined ? null : JSON.parse(bet.OpaqueData);

        let betType = getText(getAFMarketNameByCode(marketInfo.marketCode), this.props.store, [homeTeam, awayTeam]);
        let odd = bet.Market.Price;

        let name = this._getMarketDetails(marketInfo.afSelection, awayTeam, homeTeam);

        if (this.props.betsType !== PLACED && this.props.betsType !== VOIDED && !voidStatus) {
            eventDetails = (
                <div className={style.eventDetailsWrapper}>
                    <div className={style.eventDetails}>
                        {this._createEventDetails(bet)}</div>
                </div>
            );

            eventName.formated = (<div className={style.footballTitle}>
                <div className={style.eventTime}>{`${eventName.dayMonthYear} `} {`${eventName.hoursMinutes} `}</div>
                <p className={style.resultContainer}>
                    {`${title}`}</p>
            </div>);
        }

        return (<LockedBet store={this.props.store} index={this.props.index} betSelection={this.props.betSelection}
                           betType={betType} odd={odd} eventName={eventName} names={[name]}
                           isSettledBet={this.props.isSettledBet} eventDetails={eventDetails}
                           voidStatus={voidStatus}/>);
    }
}

export default LockedBetAmericanFootball;



// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/modules/americanFootball/components/lockedBetAmericanFootball.js